import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './Profile.css';

const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.tocoroyo.poppygrid.prod';
const IOS_URL = 'https://apps.apple.com/app/id6755103014';

function isAndroid() {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

function isIOS() {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function isMobile() {
  return isAndroid() || isIOS();
}

export default function Broadcast() {
  const { broadcastId } = useParams();
  const [autoRedirect, setAutoRedirect] = useState(false);
  const deepLink = broadcastId 
    ? `poppygrid://broadcast/${broadcastId}` 
    : `poppygrid://broadcast`;
  const storeUrl = isAndroid() ? ANDROID_URL : isIOS() ? IOS_URL : null;

  // Auto-redirect pattern for both Android and iOS
  // Try to open the app, if not installed redirect to store
  useEffect(() => {
    if (isMobile() && storeUrl) {
      let timeout;
      let appOpened = false;

      // For iOS: detect if page becomes hidden (app opened)
      const handleVisibilityChange = () => {
        if (document.hidden) {
          appOpened = true;
          if (timeout) {
            clearTimeout(timeout);
          }
        }
      };

      // Listen for visibility changes (iOS app opening)
      if (isIOS()) {
        document.addEventListener('visibilitychange', handleVisibilityChange);
        // Also check if page is already hidden
        if (document.hidden) {
          appOpened = true;
        }
      }

      // Try to open the app
      window.location.href = deepLink;
      
      // If app isn't installed, after 1.5s we'll still be here → go to store
      // Use slightly longer timeout for iOS to account for popup delay
      timeout = setTimeout(() => {
        if (!appOpened) {
          setAutoRedirect(true);
          window.location.href = storeUrl;
        }
      }, isIOS() ? 1500 : 1000);

      return () => {
        if (timeout) {
          clearTimeout(timeout);
        }
        if (isIOS()) {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
      };
    }
  }, [deepLink, storeUrl]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (autoRedirect) {
    return (
      <div className="profile-container">
        <div className="profile-content">
          <p>Redirecting to app store...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-content">
        <h1>PoppyGrid Broadcast</h1>
        <p className="profile-message">
          To view this broadcast, open it in the PoppyGrid app.
        </p>

        <div className="profile-actions">
          <a 
            href={deepLink} 
            className="action-button primary"
          >
            Open in App
          </a>
          
          {isAndroid() && (
            <a 
              href={ANDROID_URL} 
              target="_blank" 
              rel="noopener noreferrer"
              className="action-button"
            >
              Get it on Google Play
            </a>
          )}
          
          {isIOS() && (
            <a 
              href={IOS_URL} 
              target="_blank" 
              rel="noopener noreferrer"
              className="action-button"
            >
              Download on App Store
            </a>
          )}

          {!isMobile() && (
            <>
              <a 
                href={ANDROID_URL} 
                target="_blank" 
                rel="noopener noreferrer"
                className="action-button"
              >
                Get it on Google Play
              </a>
              <a 
                href={IOS_URL} 
                target="_blank" 
                rel="noopener noreferrer"
                className="action-button"
              >
                Download on App Store
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

